import { render, staticRenderFns } from "./ComplateSwiper.vue?vue&type=template&id=69960659&scoped=true&"
import script from "./ComplateSwiper.vue?vue&type=script&lang=js&"
export * from "./ComplateSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ComplateSwiper.vue?vue&type=style&index=0&id=69960659&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69960659",
  null
  
)

export default component.exports